import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiProfileViewComponent } from './profile-view.component';
import { FiProfileViewImageComponent } from './image/profile-view-image.component';
import { FiProfileViewDataChildComponent, FiProfileViewDataComponent } from './data/profile-view-data.component';
import { MatCardModule } from '@angular/material/card';
import { FiProfileViewTranscludeComponent } from './profile-view-transclude.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FiProfileIconModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatMenuModule,
    ],
    declarations: [
        FiProfileViewComponent,
        FiProfileViewImageComponent,
        FiProfileViewDataComponent,
        FiProfileViewDataChildComponent,
        FiProfileViewTranscludeComponent,
    ],
    exports: [
        FiProfileViewComponent,
        FiProfileViewImageComponent,
        FiProfileViewDataComponent,
        FiProfileViewDataChildComponent,
        FiProfileViewTranscludeComponent,
    ],
})
export class FiProfileViewModule {}
